module.exports = __webpack_public_path__ + "static/media/RUNE.b05958f3.svg";